/**
* Featured Video Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Video Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'featured-video-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-video-hero' ).each( function( key, component ) {
        let navHeight = $( '.navbar' ).height();
        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).height();
        }

        const leftTop = $( component ).find( '.side-colors .image-top-bg.left' )[0];
        const leftBottom = $( component ).find( '.side-colors .image-bottom-bg.left' )[0];
        const rightTop = $( component ).find( '.side-colors .image-top-bg.right' )[0];
        const rightBottom = $( component ).find( '.side-colors .image-bottom-bg.right' )[0];
        const height = $( this ).outerHeight();

        const boxWidth = $( component ).find( '.featured-video-hero__media-inner' ).offset().left;
        $( component ).find( '.image-box' ).each( function( boxKey, box ) {
          $( box ).width( boxWidth );
        } );

        if ( window.hasMotion ) {
          let end = '100% 100%';
          if ( ( window.innerHeight - navHeight ) >= height ) {
            end = '100% 50%';
          }

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: 'top ' + navHeight,
              end: end,
              scrub: 0,
            },
          } );
          tl.to( leftTop, {scaleX: 0, ease: 'linear'}, 0 );
          tl.to( leftBottom, {scaleX: 0, ease: 'linear'}, 0 );
          tl.to( rightTop, {scaleX: 0, ease: 'linear'}, 0 );
          tl.to( rightBottom, {scaleX: 0, ease: 'linear'}, 0 );
        }
      } );

      $( window ).on( 'resize', function() {
        const boxWidth = $( '.featured-video-hero' ).find( '.featured-video-hero__media-inner' ).offset().left;

        window.throttle( () => {
          $( '.featured-video-hero' ).find( '.image-box' ).each( function( boxKey, box ) {
            $( box ).width( boxWidth );
          } );
        }, 750 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-video-hero', COMPONENT );
} )( app );
